import React from 'react';
import { Flag, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Full neutral list: nothing here hints which concerns apply to the patient
const CONCERN_GROUPS = [
  { title: 'Vital Signs', items: [
    ['vital_bp_low', 'Hypotension'], ['vital_bp_high', 'Hypertension'], ['vital_hr_tachy', 'Tachycardia'],
    ['vital_hr_brady', 'Bradycardia'], ['vital_spo2_low', 'Hypoxia'], ['vital_rr_abnormal', 'Abnormal Respiratory Rate'],
    ['vital_temp_fever', 'Fever'], ['vital_temp_hypo', 'Hypothermia'],
  ] },
  { title: 'Clinical Findings', items: [
    ['pain_uncontrolled', 'Uncontrolled Pain'], ['resp_distress', 'Respiratory Distress'], ['neuro_change', 'Neurological Change Risk'],
    ['cardiac_chest_pain', 'Chest Pain'], ['cardiac_arrhythmia', 'Arrhythmia Risk'], ['bleeding', 'Bleeding Risk'],
    ['infection_signs', 'Infection Signs'], ['fluid_imbalance', 'Fluid Imbalance'],
  ] },
  { title: 'Safety & Escalation', items: [
    ['fall_risk', 'Fall Risk'], ['med_error_risk', 'Medication Safety'], ['allergic_reaction', 'Allergy Risk'],
    ['notify_provider', 'Notify Provider'],
  ] },
];

export const FlagConcernsPanel = ({ patient, selected, onToggle, onSubmit, onCancel, loading }) => (
  <div className="bg-white rounded-xl border-2 border-amber-300 p-4" data-testid="flag-concerns-panel">
    <h3 className="font-bold text-slate-800 mb-1 flex items-center gap-2">
      <Flag className="w-5 h-5 text-amber-700" />
      Flag Concerns: {patient.name}
    </h3>
    <p className="text-sm text-slate-700 mb-3">
      Review the vitals, diagnosis and chart, then flag only the concerns supported by this patient's data.
    </p>
    <div className="space-y-3 max-h-[400px] overflow-y-auto">
      {CONCERN_GROUPS.map(group => (
        <div key={group.title}>
          <p className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">{group.title}</p>
          <div className="grid grid-cols-2 gap-2">
            {group.items.map(([id, label]) => {
              const isOn = selected.includes(id);
              return (
                <button
                  key={id}
                  type="button"
                  onClick={() => onToggle(id)}
                  className={`text-left text-sm px-2 py-1.5 rounded border transition-colors flex items-center gap-1 ${isOn ? 'bg-amber-100 border-amber-500 text-amber-900' : 'bg-white border-slate-300 text-slate-800 hover:border-amber-400'}`}
                  data-testid={`concern-option-${id}`}
                >
                  {isOn && <CheckCircle className="w-3.5 h-3.5 shrink-0" />}
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
    <div className="flex gap-2 mt-4">
      <Button onClick={onSubmit} disabled={loading || selected.length === 0} className="flex-1 bg-amber-600 hover:bg-amber-700 text-white" data-testid="submit-flag-concerns-btn">
        Submit Concerns ({selected.length})
      </Button>
      <Button variant="outline" onClick={onCancel} data-testid="cancel-flag-concerns-btn">Cancel</Button>
    </div>
  </div>
);
